import { ButtonTriggerEvent } from '../../../../common/components';
import { Account } from '../../../../models/admin/account';

export class TravelBuddySettingsModalActions {
  confirm: (event: ButtonTriggerEvent) => void;
  cancel?: () => void;
}

export class TravelBuddySettingsModalData {
  account: Account;
  constructor(account?) {
    this.account = account;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/travel.buddy.settings/travel.buddy.settings.modal.provider.ts